<template>
  <h1>About me</h1>
  <div class="flex">
    <div class="center">
      <div class="flip-card">
        <div class="flip-card-inner">
          <div class="flip-card-front">
            <img
              src="../assets/JordanPic.jpeg"
              alt="Avatar"
              style="width: 450px; height: 450px;border: 9px solid #bf0000;"
            />
          </div>
          <div class="flip-card-back">
            <div class="container" style="padding:20px">
              <div class="row">
                <div class="col-6">
                  <ul class="listing">
                    <li>DOB: 5 November 2001</li>
                    <li>FullName: Jordan Rodrique Duncan Dawson</li>
                    <li>Phone number: 076 673 0868</li>
                  </ul>
                </div>
                <div class="col-6">
                  <ul class="listing">
                    <li></li>
                    <li></li>
                    <li></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="landing-text">
      <h1>Jordan Dawson</h1>
      <h2>Creative Web App Developer</h2>
      <p>
        I am a goal-orientated and driven individual who is meticulous in the
        work that I do. As a detail orientated individual, and I am able to
        focus on all the finer elements that are needed to achieve a project
        well.
      </p>
    </div>
  </div>
</template>

<script>
export default {

};
</script>

<style scoped>
  body {
  background-color: #1c1c1c !important;
  font-family: Helvetica, sans-serif;
}
h1 {
  font-weight: bold;
  text-decoration-line: underline;
}

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
.listing {
  list-style: none;
  font-size: 12px;
  padding: 20px;
}

.flex {
  display: flex;
  margin-left: 30px;
  margin-right: 30px;
  margin-bottom: 20px !important;
}

.landing-text,
.landing-img {
  width: 50%;
}

.landing-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 30px;
  color: white;
  text-align: left;
}

.landing-img {
  max-height: 100vh;
  object-fit: cover;
}
.row {
  margin: 5px;
  background-color: rgba(2, 38, 70, 0.35);
  border-radius: 25px;
  text-align: left;
  font-size: 15px;
}
@media screen and (max-width: 500px) {
  .flex {
    flex-direction: column;
  }
  .landing-text,
  .landing-img {
    width: 100%;
  }
}

.flip-card {
  background-color: transparent;
  width: 450px;
  height: 450px;
  
  perspective: 1000px; 
}


.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.8s;
  transform-style: preserve-3d;
}


.flip-card:hover .flip-card-inner {
  transform: rotateY(180deg);
}


.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden; 
  backface-visibility: hidden;
}


.flip-card-front {
  background-color: #bbb;
  color: black;
}

.flip-card-back {
  background-color: #bf0000;
  color: white;
  transform: rotateY(180deg);
}
</style>
